'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var useDevelopmentEffect = require('../../_chunks/useDevelopmentEffect-DGG0KnB_.js');
var icons_IconOpenIn = require('../../icons/IconOpenIn.js');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');
require('../../icons/Icon.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

require("../../_assets/Link-CVvjsV6V.css");var styles = {"link":"Link__CPhR8IXqm___link"};

const Link = react.forwardRef(({ as, external, className, theme, children, testId, ...props }, ref) => {
    const As = as ?? 'a';
    useDevelopmentEffect.useDevelopmentEffect(() => {
        // the Link component in react-router has the display name of "Link"
        if (as && as.displayName !== 'Link') {
            const asComponent = as;
            console.error(`[Link] The \`as\` property should only be used with React Router links. It looks like the component that you passed does not match the criteria:`, asComponent.displayName ?? asComponent.name ?? asComponent);
        }
    }, [as]);
    return (jsxRuntime.jsxs(As, { className: utilities_combineClasses.combineClasses(styles.link, className), target: external ? '_blank' : undefined, rel: 
        // older browsers might not set the "noopener" implicitly
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#security_and_privacy
        external ? 'noopener' : undefined, "data-theme": theme, "data-testid": testId, ...props, ref: ref, children: [children, external && jsxRuntime.jsx(icons_IconOpenIn.IconOpenIn, {})] }));
});
Link.displayName = 'Link';

exports.Link = Link;
//# sourceMappingURL=Link.js.map
